
<template>
  <v-form ref="form"  lazy-validation>
    <v-text-field 
      v-model="company_credit.limit" 
      :rules="required" 
      v-money="money" 
      label="Limite de Crédito (R$)" 
      prepend-icon="mdi-cash-multiple"
    ></v-text-field>
    <v-text-field 
      v-model="company_credit.blockingTime" 
      :rules="required" 
      label="Prazo para bloqueio" 
      suffix="dias" 
      type="tel" 
      prepend-icon="mdi-calendar-clock"
    ></v-text-field>
  </v-form>
</template>

<script>
import { VMoney } from 'v-money'
import validations from "@/mixins/validations.js"

export default {
  name: 'CompanyCreditForm',
  mixins: [ validations ],
  directives: { money: VMoney },
  props:{
    company_credit:{
      required: true,
      type: Object,
    },
    read_only:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: true
      },
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
  },
}
</script>
